import { TFunction } from "i18next";

import { TABLE_NAMES, useFormattedNumber } from "../../../../shared";

interface SchedulesMainDialogContentProps {
  isSelectedTab: boolean;
  isFilteredTab: boolean;
  isAllTab: boolean;
  resourceName: TABLE_NAMES;
  totalCount: number | undefined;
  resourceCount: number;
  t: TFunction<"translation", undefined>;
}

const useSchedulesMainDialogContent = ({
  isSelectedTab,
  isFilteredTab,
  isAllTab,
  resourceName,
  totalCount,
  resourceCount,
  t
}: SchedulesMainDialogContentProps) => {
  const { renderFormattedNumber } = useFormattedNumber();

  const generateBadgeText = () => {
    if (isSelectedTab) {
      return t(`Dialog##selected ${resourceName}`);
    } else if (isFilteredTab) {
      return t(`Dialog##filtered ${resourceName}`);
    }
    return "";
  };

  const generateItemsCountToDisplay = () => {
    if (isSelectedTab) {
      return `${renderFormattedNumber(resourceCount)}`;
    } else {
      return totalCount;
    }
  };

  const generateSelectedTabDescription = () => {
    if (isSelectedTab) {
      return t(`Dialog##schedule apply to selected##${resourceName}`);
    } else if (isFilteredTab) {
      return t(`Dialog##schedule apply to filtered##${resourceName}`);
    } else if (isAllTab) {
      return t(`Dialog##schedule apply to all##${resourceName}`);
    }
  };

  return {
    generateBadgeText,
    generateItemsCountToDisplay,
    generateSelectedTabDescription
  };
};

export default useSchedulesMainDialogContent;
